module.exports = __webpack_public_path__ + "static/media/consultorio.2397e676.jpeg";